import i18next from "i18next";
import {initReactI18next} from "react-i18next";
// "Inline" English and Arabic translations.
// We can localize to any language and any number of languages.
const resources = {
    de: {
        translation: {
            floorplan_cells: "Zellen",
            floorplan_faces: "zeigt nach",
            floorplan_light_title: "{{kind}}-Licht · {{state}} · r {{radius}}",
            ui_create: "Erstellen",
            ui_list: "Liste",
            menu_misc: "Sonstiges",
            feedback_thanks: "Danke für das Feedback!",
            feedback_error: "Selbst das Senden von Feedback funktioniert gerade nicht. Bitte sende dein Feedback per E-Mail an:",
            feedback_email_placeholder: "Deine E-Mail (optional)",
            feedback_comment_placeholder: "Gibt es einen Bug? Verbesserungsvorschläge? Möchtest du dein Lieblingsrezept für Kekse teilen?",
            feedback_send: "Absenden",
            error_title: "Ups! Falsche Abbiegung in der Matrix genommen...",
            error_greeting: "Hey Chummer,",
            error_body: "es sieht so aus, als hätten wir eine unerwartete Störung in der Matrix. Vielleicht wurde die gesuchte Verbindung von einem feindlichen Megakonzern gelöscht oder ein rachsüchtiger Sprite hat sie in den digitalen Abgrund gezogen.",
            profile_wip: "An dieser Seite wird noch gearbeitet.",
            auth_login: "Anmelden",
            auth_email: "E-Mail",
            auth_password: "Passwort",
            auth_password_repeat: "Passwort (wiederholt)",
            npc_metatype: "Metatyp",
            npc_profession: "Beruf",
            search_placeholder: "Wortsuche / RegEx",
            prompt_generate: "Generieren",
            prompt_examples: "Ideen:",
            prompt_random: "Zufall",
            language_label: "Sprache",
            app_name: "Schattenakte - Shadowrun NPC Generator",
            prompt_failed_connection: "Verbindungsprobleme. Bitte versuche es später erneut.",
            input_was_flagged_by_gpt: 'Die Eingabe wurde von der GPT Moderation ausgefiltert. Versuche es erneut oder gib etwas anderes ein.',
            npc_was_flagged_by_gpt: 'Der NPC wurde von GPT als unangemessen eingeschätzt. Versuche es erneut oder gib etwas anderes ein.',
            gpt_raised_an_error: 'GPT hat einen Fehler geworfen. Bitte versuche es später erneut.',
            npc_incomplete: 'Der NPC ist unvollständig. Bitte fülle alle Felder aus bevor du speicherst.',
            image_generation_in_progress: 'Das Bild wird derzeit erstellt und in Kürze angezeigt.',
            prompt_wait: "Wird generiert... bitte warten...",

            header_profile: "Account",

            page_prompt_title: "Schattenakte - Generator",
            page_impressum_title: "Schattenakte - Impressum",
            page_login_title: "Schattenakte - Login",
            page_profile_title: "Schattenakte - Account",
            page_list_title: "Schattenakte - Liste",
            page_list_description: "Liste aller Akteneinträge",

            favorite_list_empty_text: "Du hast noch keine Favoriten hinzugefügt. Klicke auf das Sternsymbol in einem Eintrag, um ihn zu deinen Favoriten hinzuzufügen.",
            search_list_empty_text: "Deine Suche ergab keine Ergebnisse. Versuche es mit einem anderen Suchbegriff.",
            npc_list_empty_text: "Das sollte nie passieren. Entweder ist dein Internet oder der Server down. Versuche es später erneut.",
            location_list_empty_text: "Das sollte nie passieren. Entweder ist dein Internet oder der Server down. Versuche es später erneut.",
            own_list_empty_text: "Du hast noch keine Einträge erstellt. Klicke auf das Plus, um einen neuen Eintrag zu erstellen.",

            menu_npcs: 'NPCs',
            menu_locations: 'Locations',
            menu_critters: 'Critters',
            menu_vehicles: 'Vehicles',
            menu_customs: "Bildgenerator",
            menu_feedback: "Feedback",
            menu_impressum: "Impressum",

            tab_header_floorplans_list: "Grundrisse",
            tab_header_floorplans_create: "Grundrisse",
            menu_floorplans: "Grundrisse",
            floorplan_list_empty_text: "Es gibt noch keine veröffentlichten Grundrisse. Klicke auf das Plus, um einen zu erstellen.",
            page_floorplan_create_title: "Schattenakte - Grundriss",
            create_explanation_floorplan: "Stelle das Gebäude ein und generiere einen Grundriss mit Räumen, Türen, Möbeln und Sicherheitstechnik. Ein Grundriss kann nicht geändert werden; andere Einstellungen ergeben einen neuen.",
            floorplan_is_not_published: "Dieser Grundriss wurde noch nicht veröffentlicht und kann nur durch die exakte URL aufgerufen werden. Speichere den Link, um später darauf zugreifen zu können.",
            floorplan_options_failed: "Die Einstellungen konnten nicht geladen werden.",
            floorplan_load_failed: "Der Grundriss konnte nicht geladen werden.",
            floorplan_loading: "Wird geladen...",
            floorplan_queued: "Warte auf Generierung...",
            floorplan_rendering: "Grundriss wird erstellt...",
            floorplan_failed: "Der Grundriss konnte nicht erstellt werden.",
            floorplan_empty: "Stelle links die Parameter ein und klicke auf Generieren.",
            floorplan_floor_ground: "Erdgeschoss",
            floorplan_floor_upper: "{{level}}. OG",
            floorplan_floor_basement: "UG {{level}}",
            floorplan_download: "Download",
            floorplan_unpublished: "Nicht veröffentlicht",
            floorplan_published: "Veröffentlicht",
            floorplan_to_list: "Zur Liste",
            floorplan_opt_rectangle: "Rechteck",
            floorplan_opt_l: "L-Form",
            floorplan_opt_u: "U-Form",
            floorplan_opt_t: "T-Form",
            floorplan_opt_z: "Z-Form",
            floorplan_opt_stepped: "Gestaffelt",
            floorplan_opt_irregular: "Unregelmäßig",
            floorplan_opt_osm: "Echtes Gebäude (OSM)",
            floorplan_opt_squatter: "Hausbesetzer",
            floorplan_opt_low: "Niedrig",
            floorplan_opt_middle: "Mittel",
            floorplan_opt_high: "Hoch",
            floorplan_opt_luxury: "Luxus",
            floorplan_opt_pristine: "Makellos",
            floorplan_opt_maintained: "Gepflegt",
            floorplan_opt_run_down: "Heruntergekommen",
            floorplan_opt_derelict: "Verfallen",
            floorplan_opt_ruined: "Ruine",
            floorplan_opt_none: "Keine",
            floorplan_opt_corporate: "Konzern",
            floorplan_opt_aaa: "AAA",
            floorplan_opt_N: "N (Nord)",
            floorplan_opt_E: "O (Ost)",
            floorplan_opt_S: "S (Süd)",
            floorplan_opt_W: "W (West)",
            floorplan_opt_neon2: "Neon",
            floorplan_opt_modern2: "Modern",
            floorplan_opt_office: "Büro",
            floorplan_opt_apartment: "Wohnblock",
            floorplan_opt_supermarket: "Supermarkt",
            floorplan_opt_clinic: "Klinik",
            floorplan_opt_hospital: "Krankenhaus",
            floorplan_opt_hotel: "Hotel",
            floorplan_opt_corp_lab: "Konzernlabor",
            floorplan_opt_nightclub: "Nachtclub",
            floorplan_opt_warehouse: "Lagerhalle",
            floorplan_opt_police_station: "Polizeiwache",
            floorplan_opt_parking_garage: "Parkhaus",
            floorplan_opt_factory: "Fabrik",
            floorplan_opt_church: "Kirche",
            floorplan_opt_data_centre: "Rechenzentrum",
            floorplan_opt_casino: "Casino",
            floorplan_opt_corp_office: "Konzernbüro",
            floorplan_opt_street_doc: "Straßendoc",
            floorplan_opt_cosmetic_clinic: "Schönheitsklinik",
            floorplan_opt_coffin_block: "Sargmotel",
            floorplan_opt_stuffer_shack: "Stuffer Shack",
            floorplan_opt_dive_bar: "Spelunke",
            floorplan_opt_chop_shop: "Chop Shop",
            floorplan_opt_gun_shop: "Waffenladen",
            floorplan_opt_talismonger: "Talismonger",
            floorplan_opt_ramen_bar: "Ramen-Bar",
            floorplan_opt_boutique: "Boutique",
            floorplan_opt_deli: "Feinkost",
            floorplan_opt_safehouse: "Safehouse",
            floorplan_opt_hacker_den: "Hackerhöhle",
            floorplan_opt_mage_flat: "Magierwohnung",
            floorplan_opt_prison: "Gefängnis",
            floorplan_publish: "Veröffentlichen",
            floorplan_generate: "Generieren",
            floorplan_floors_one: "{{count}} Stockwerk",
            floorplan_floors_other: "{{count}} Stockwerke",
            floorplan_building: "Gebäude",
            floorplan_character: "Charakter",
            floorplan_site: "Grundstück",
            floorplan_image: "Bild",
            floorplan_type: "Typ",
            floorplan_width: "Breite (Zellen)",
            floorplan_depth: "Tiefe (Zellen)",
            floorplan_floors_above: "Stockwerke oben",
            floorplan_floors_below: "Keller",
            floorplan_shape: "Form",
            floorplan_layout: "Layout",
            floorplan_layout_default: "wie der Gebäudetyp",
            floorplan_opt_partition: "Partition (gerade Flure)",
            floorplan_opt_partition_diagonal: "Partition, diagonale Flure",
            floorplan_opt_partition_osm: "Partition, Flure echter Gebäude (OSM)",
            floorplan_wealth: "Wohlstand",
            floorplan_condition: "Zustand",
            floorplan_security: "Sicherheit",
            floorplan_street_side: "Straßenseite",
            floorplan_service_side: "Lieferseite",
            floorplan_opposite_of_street: "gegenüber der Straße",
            floorplan_seed: "Seed",
            floorplan_random: "zufällig",
            floorplan_reroll: "Zufälliger Seed",
            floorplan_follows_layout: "wie Grundriss-Seed",
            floorplan_seed_layout: "Grundriss",
            floorplan_seed_rooms: "Räume",
            floorplan_seed_furniture: "Möbel",
            floorplan_seed_security: "Sicherheit",
            floorplan_osm_credit: "Formen echter Gebäude:",
            floorplan_light_word: "Licht",
            floorplan_theme: "Stil",
            floorplan_layers: "Ebenen",
            floorplan_floor_list: "Stockwerke",
            floorplan_role: "Rolle",
            floorplan_unit: "Einheit",
            floorplan_zoom_in: "Vergrößern",
            floorplan_zoom_out: "Verkleinern",
            floorplan_zoom_fit: "Einpassen",
            floorplan_dd2vtt_hint: "Universal VTT, z. B. für Roll20 oder Foundry",
            floorplan_layer_image: "Bild",
            floorplan_layer_labels: "Raumbeschreibungen",
            floorplan_layer_objects: "Möbel",
            floorplan_layer_matrix: "Matrix-Geräte",
            floorplan_layer_grid: "Raster",

            menu_login: 'Login',
            menu_register: 'Register',
            menu_logout: 'Logout',



            tab_header_npc_list: "NPCs",
            tab_header_npc_create: "NPCs",
            tab_header_locations_list: "Orte",
            tab_header_locations_create: "Orte",
            tab_header_customs_list: "Bildgenerator",
            tab_header_customs_create: "Bildgenerator",
            tab_header_favorites_list: "Favoriten",
            tab_header_own_list: "Eigene Einträge",

            tab_header_npcs_default: 'NPC',
            tab_header_npcs_sr6: 'SR6',
            tab_header_npcs_sr5: 'SR5',
            tab_header_npcs_gallery: 'Galerie',
            tab_header_locations_default: 'Location',
            tab_header_locations_reviews: 'Reviews',
            tab_header_locations_gallery: 'Galerie',

            create_explanation_npc: 'Beschreibe deinen NPC. Du kannst Aussehen, Beruf, den Hintergrund oder sogar Werte angeben, GPT erzeugt dann den Rest. Du kannst ihn danach noch abändern.',
            create_explanation_location: 'Beschreibe den Ort. Du kannst das Gebiet oder eine grobe Beschreibung dazuschreiben. GPT erzeugt dann den Rest. Du kannst ihn danach noch abändern.',
            create_explanation_custom: 'Beschreibe etwas grobes und lass GPT ausfüllen - oder gib unten direkt das Aussehen an',

            entity_create: 'Erstellen',
            entity_generate_data: 'Generiere fehlende Daten ...',
            entity_download: 'Download',
            entity_download_title: 'Download',
            entity_download_format_picker: "Wähle das Format aus:",
            entity_download_foundryvtt: '(SR6) Foundry VTT',
            entity_download_foundryvtt_description1: 'Lege einen neuen "Actor" in Foundry an.',
            entity_download_foundryvtt_description2: 'Rechtsklick auf den Actor -> "Import data".',
            entity_download_foundryvtt_description3: 'Wähle die heruntergeladene Datei.',
            entity_download_foundryvtt_description4: 'Falls das Bild fehlt, importiere die Datei erneut.',
            entity_download_error: 'Export fehlgeschlagen. Bitte fülle den NPC vollständig aus und versuche es erneut.',
            entity_download_roll20: '(SR6) Roll20',
            entity_download_roll20_description1: 'Öffne den Shadowrun-6-Charakterbogen in Roll20 und den Reiter "Import".',
            entity_download_roll20_description2: 'Lade die heruntergeladene JSON-Datei hoch.',
            entity_save: 'Veröffentlichen',
            entity_favorite: 'Favorisieren',

            attribute_metatype: 'Metatyp',
            attribute_profession: 'Beruf',
            attribute_ethnicity: 'Ethnizität',
            attribute_gender: 'Geschlecht',
            attribute_age: 'Alter',
            attribute_quirks: 'Eigenarten',
            attribute_appearance: 'Aussehen',

            attribute_backstory: 'Geschichte',
            attribute_experiences: 'Erfahrung',
            attribute_resentments: 'Abneigung',
            attribute_motivations: 'Motivation',
            attribute_hobbies_and_interests: 'Hobbys',
            attribute_family: 'Familie',
            attribute_contacts: 'Kontakte',

            attribute_strengths: 'Stärken',
            attribute_weaknesses: 'Schwächen',
            attribute_skills: 'Fertigkeiten',
            attribute_equipment: 'Ausrüstung',
            attribute_secret: 'Geheimnis',

            attribute_name: 'Name',
            attribute_type: 'Typ',
            attribute_aussehen: 'Aussehen',
            attribute_special_features: 'Besonderheiten',
            attribute_besonderheiten: 'Besonderheiten',
            attribute_remarks: 'Hinweise',
            attribute_security_systems: 'Sicherheit',
            attribute_events: 'Aktionen',
            attribute_rumors_and_stories: 'Gerüchte',

            attribute_parameter: 'Parameter',

            metatype_human: 'Mensch',
            metatype_ork: 'Ork',
            metatype_dwarf: 'Zwerg',
            metatype_elf: 'Elf',
            metatype_troll: 'Troll',
            metatype_spirit: 'Geist',
            metatype_ai: 'KI',
            metatype_ogre: 'Oger',
            metatype_drake: 'Drake',
            metatype_oni: 'Oni',
            metatype_hobgoblin: 'Hobgoblin',
            metatype_other: 'Andere',
            metatype_giant: 'Riese',
            metatype_cyclop: 'Zyklop',
            metatype_minotaur: 'Minotaur',
            metatype_fomorian: 'Fomori',
            metatype_satyr: 'Satyr',
            metatype_nocturne: 'Nocturna',
            metatype_wakyambi: 'Wakyambi',
            metatype_xapiri: 'Xapiri',
            metatype_dryad: 'Dryade',
            metatype_dalakitnon: 'Dalakitnon',
            metatype_valkyrie: 'Walküre',
            metatype_nartaki: 'Nartaki',
            metatype_duende: 'Duende',
            metatype_hanuman: 'Hanuman',
            metatype_menehune: 'Menehune',
            metatype_koborokuru: 'Koborokuru',
            metatype_gnome: 'Gnom',
            metatype_centaur: 'Zentaur',
            metatype_naga: 'Naga',
            metatype_pixie: 'Pixie',
            metatype_sasquatch: 'Sasquatch',

            gender_male: 'Männlich',
            gender_female: 'Weiblich',
            gender_divers: 'Divers',
            gender_other: 'Andere',

            "--s 50": "stylize low",
            "--s 100": "stylize medium",
            "--s 250": "stylize high",
            "--s 750": "stylize very high",

            "--ar 1:1": "Quadratisch (1:1)",
            "--ar 2:3": "Hoch (2:3)",
            "--ar 4:7": "Portrait (4:7)",
            "--ar 3:2": "Breit (3:2)",
            "--ar 7:4": "Landschaft (7:4)",

            "--chaos 0": "Kein Chaos",
            "--chaos 7": "Wenig Chaos",
            "--chaos 25": "Mittleres Chaos",
            "--chaos 50": "Hohes Chaos",
            "--chaos 100": "Maximales Chaos",

            tab_loading_text: "Daten werden generiert...",


            npc_card_title_background: 'Hintergrund',
            npc_card_title_social: 'Soziales',
            npc_card_title_personality: 'Persönlichkeit',
            npc_card_title_skills_and_traits: 'Eigenschaften',

            npc_attribute_bod: 'Kon',
            npc_attribute_agi: 'Agi',
            npc_attribute_rea: 'Rea',
            npc_attribute_str: 'Str',
            npc_attribute_wil: 'Wil',
            npc_attribute_log: 'Log',
            npc_attribute_int: 'Int',
            npc_attribute_cha: 'Cha',
            npc_attribute_edg: 'Edg',
            npc_attribute_mag: 'Mag',
            npc_attribute_res: 'Res',

            npc_skill_astral: 'Astral',
            npc_skill_athletics: 'Athletik',
            npc_skill_biotech: 'Biotech',
            npc_skill_close_combat: 'Nahkampf',
            npc_skill_con: 'Überreden',
            npc_skill_conjuring: 'Beschwören',
            npc_skill_cracking: 'Cracken',
            npc_skill_electronics: 'Elektronik',
            npc_skill_enchanting: 'Verzaubern',
            npc_skill_engineering: 'Mechanik',
            npc_skill_exotic_weapons: 'Exotische Waffen',
            npc_skill_firearms: 'Feuerwaffen',
            npc_skill_influence: 'Einfluss',
            npc_skill_outdoors: 'Natur',
            npc_skill_perception: 'Wahrnehmung',
            npc_skill_piloting: 'Steuern',
            npc_skill_sorcery: 'Hexerei',
            npc_skill_stealth: 'Heimlichkeit',
            npc_skill_tasking: 'Tasken',

            npc_sr5_skill_archery: 'Bogenschießen',
            npc_sr5_skill_automatics: 'Automatikwaffen',
            npc_sr5_skill_blades: 'Klingenwaffen',
            npc_sr5_skill_clubs: 'Knüppel',
            npc_sr5_skill_exotic_melee_weapon: 'Exotische Nahkampfwaffe',
            npc_sr5_skill_exotic_ranged_weapon: 'Exotische Fernkampfwaffe',
            npc_sr5_skill_heavy_weapons: 'Schwere Waffen',
            npc_sr5_skill_longarms: 'Gewehre',
            npc_sr5_skill_pistols: 'Pistolen',
            npc_sr5_skill_throwing_weapons: 'Wurfwaffen',
            npc_sr5_skill_unarmed_combat: 'Waffenloser Kampf',
            npc_sr5_skill_gunnery: 'Geschütze',
            npc_sr5_skill_disguise: 'Verkleiden',
            npc_sr5_skill_diving: 'Tauchen',
            npc_sr5_skill_escape_artist: 'Entfesselungskunst',
            npc_sr5_skill_free_fall: 'Freifall',
            npc_sr5_skill_gymnastics: 'Akrobatik',
            npc_sr5_skill_locksmith: 'Schlossknacken',
            npc_sr5_skill_palming: 'Taschenspielerei',
            npc_sr5_skill_perception: 'Wahrnehmung',
            npc_sr5_skill_running: 'Laufen',
            npc_sr5_skill_sneaking: 'Schleichen',
            npc_sr5_skill_survival: 'Überleben',
            npc_sr5_skill_swimming: 'Schwimmen',
            npc_sr5_skill_tracking: 'Spurensuche',
            npc_sr5_skill_animal_handling: 'Tierführung',
            npc_sr5_skill_con: 'Überreden',
            npc_sr5_skill_etiquette: 'Etikette',
            npc_sr5_skill_impersonation: 'Verstellen',
            npc_sr5_skill_instruction: 'Unterricht',
            npc_sr5_skill_intimidation: 'Einschüchtern',
            npc_sr5_skill_leadership: 'Führungsqualität',
            npc_sr5_skill_negotiation: 'Verhandlung',
            npc_sr5_skill_performance: 'Darbietung',
            npc_sr5_skill_alchemy: 'Alchemie',
            npc_sr5_skill_arcana: 'Arkanum',
            npc_sr5_skill_artificing: 'Artefaktherstellung',
            npc_sr5_skill_assensing: 'Aurenlesen',
            npc_sr5_skill_astral_combat: 'Astralkampf',
            npc_sr5_skill_banishing: 'Bannen',
            npc_sr5_skill_binding: 'Binden',
            npc_sr5_skill_counterspelling: 'Spruchabwehr',
            npc_sr5_skill_disenchanting: 'Entzaubern',
            npc_sr5_skill_ritual_spellcasting: 'Ritualzauberei',
            npc_sr5_skill_spellcasting: 'Spruchzauberei',
            npc_sr5_skill_summoning: 'Beschwören',
            npc_sr5_skill_compiling: 'Kompilieren',
            npc_sr5_skill_decompiling: 'Dekompilieren',
            npc_sr5_skill_registering: 'Registrieren',
            npc_sr5_skill_aeronautics_mechanic: 'Luftfahrzeugmechanik',
            npc_sr5_skill_armorer: 'Waffenschmied',
            npc_sr5_skill_artisan: 'Kunsthandwerk',
            npc_sr5_skill_automotive_mechanic: 'Kraftfahrzeugmechanik',
            npc_sr5_skill_biotechnology: 'Biotechnologie',
            npc_sr5_skill_chemistry: 'Chemie',
            npc_sr5_skill_computer: 'Computer',
            npc_sr5_skill_cybercombat: 'Cyberkampf',
            npc_sr5_skill_cybertechnology: 'Cybertechnologie',
            npc_sr5_skill_demolitions: 'Sprengstoffe',
            npc_sr5_skill_electronic_warfare: 'Elektronische Kriegsführung',
            npc_sr5_skill_first_aid: 'Erste Hilfe',
            npc_sr5_skill_forgery: 'Fälschen',
            npc_sr5_skill_hacking: 'Hacken',
            npc_sr5_skill_hardware: 'Hardware',
            npc_sr5_skill_industrial_mechanic: 'Industriemechanik',
            npc_sr5_skill_medicine: 'Medizin',
            npc_sr5_skill_nautical_mechanic: 'Wasserfahrzeugmechanik',
            npc_sr5_skill_navigation: 'Navigation',
            npc_sr5_skill_software: 'Software',
            npc_sr5_skill_pilot_aerospace: 'Pilot Raumfahrzeug',
            npc_sr5_skill_pilot_aircraft: 'Pilot Luftfahrzeug',
            npc_sr5_skill_pilot_exotic_vehicle: 'Pilot Exotisches Fahrzeug',
            npc_sr5_skill_pilot_ground_craft: 'Pilot Bodenfahrzeug',
            npc_sr5_skill_pilot_walker: 'Pilot Läufer',
            npc_sr5_skill_pilot_watercraft: 'Pilot Wasserfahrzeug',

            npc_sr5_category_combat: 'Kampf',
            npc_sr5_category_physical: 'Körperlich',
            npc_sr5_category_social: 'Sozial',
            npc_sr5_category_magical: 'Magie',
            npc_sr5_category_resonance: 'Resonanz',
            npc_sr5_category_technical: 'Technik',
            npc_sr5_category_vehicle: 'Fahrzeuge',

            npc_entity_is_not_published: 'Dieser NPC wurde noch nicht veröffentlicht und kann nur durch die exakte URL aufgerufen werden. Speichere den Link, um später darauf zugreifen zu können.',

            npc_skill: 'Fertigkeit',
            npc_skill_value: 'Wert',

            npc_physical_condition: 'Körperlich',
            npc_stun_condition: 'Geistig',


            location_entity_is_not_published: 'Diese Location wurde noch nicht veröffentlicht und kann nur durch die exakte URL aufgerufen werden. Speichere den Link, um später darauf zugreifen zu können.',


            auth_signup: 'Registrieren',
            auth_signup_description: 'Noch keinen Account? Hier registrieren',
        },
    },
    en: {
        translation: {
            "floorplan_cells": "cells",
            "floorplan_faces": "faces",
            "floorplan_light_title": "{{kind}} light · {{state}} · r {{radius}}",
            "ui_create": "Create",
            "ui_list": "List",
            "menu_misc": "Misc",
            "feedback_thanks": "Thanks for the feedback!",
            "feedback_error": "Even sending feedback isn't working right now. Please send your feedback by email to:",
            "feedback_email_placeholder": "Your email (optional)",
            "feedback_comment_placeholder": "Found a bug? Suggestions? Want to share your favourite cookie recipe?",
            "feedback_send": "Send",
            "error_title": "Oops! Took a wrong turn in the Matrix...",
            "error_greeting": "Hey Chummer,",
            "error_body": "it looks like we have an unexpected glitch in the Matrix. Maybe the connection you were looking for was deleted by a hostile megacorp, or a vengeful sprite dragged it into the digital abyss.",
            "profile_wip": "This page is still under construction.",
            "auth_login": "Sign in",
            "auth_email": "Email",
            "auth_password": "Password",
            "auth_password_repeat": "Password (repeat)",
            "npc_metatype": "Metatype",
            "npc_profession": "Profession",
            "search_placeholder": "Word search / RegEx",
            "prompt_generate": "Generate",
            "prompt_examples": "Ideas:",
            "prompt_random": "Surprise me",
            "language_label": "Language",
            "header_profile": "Account",
            "page_prompt_title": "Schattenakte - Generator",
            "page_impressum_title": "Schattenakte - Imprint",
            "page_login_title": "Schattenakte - Login",
            "page_profile_title": "Schattenakte - Account",
            "page_list_title": "Schattenakte - List",
            "page_list_description": "List of all file entries",
            "favorite_list_empty_text": "You haven't added any favourites yet. Click the star icon in an entry to add it to your favourites.",
            "search_list_empty_text": "Your search returned no results. Try a different search term.",
            "npc_list_empty_text": "This should never happen. Either your internet connection or the server is down. Try again later.",
            "location_list_empty_text": "This should never happen. Either your internet connection or the server is down. Try again later.",
            "own_list_empty_text": "You haven't created any entries yet. Click the plus to create a new entry.",
            "floorplan_opt_rectangle": "Rectangle",
            "floorplan_opt_l": "L-shape",
            "floorplan_opt_u": "U-shape",
            "floorplan_opt_t": "T-shape",
            "floorplan_opt_z": "Z-shape",
            "floorplan_opt_stepped": "Stepped",
            "floorplan_opt_irregular": "Irregular",
            "floorplan_opt_osm": "Real building (OSM)",
            "floorplan_opt_squatter": "Squatter",
            "floorplan_opt_low": "Low",
            "floorplan_opt_middle": "Middle",
            "floorplan_opt_high": "High",
            "floorplan_opt_luxury": "Luxury",
            "floorplan_opt_pristine": "Pristine",
            "floorplan_opt_maintained": "Maintained",
            "floorplan_opt_run_down": "Run down",
            "floorplan_opt_derelict": "Derelict",
            "floorplan_opt_ruined": "Ruined",
            "floorplan_opt_none": "None",
            "floorplan_opt_corporate": "Corporate",
            "floorplan_opt_aaa": "AAA",
            "floorplan_opt_neon2": "Neon",
            "floorplan_opt_modern2": "Modern",
            "floorplan_opt_office": "Office",
            "floorplan_opt_apartment": "Apartment block",
            "floorplan_opt_supermarket": "Supermarket",
            "floorplan_opt_clinic": "Clinic",
            "floorplan_opt_hospital": "Hospital",
            "floorplan_opt_hotel": "Hotel",
            "floorplan_opt_corp_lab": "Corporate lab",
            "floorplan_opt_nightclub": "Nightclub",
            "floorplan_opt_warehouse": "Warehouse",
            "floorplan_opt_police_station": "Police station",
            "floorplan_opt_parking_garage": "Parking garage",
            "floorplan_opt_factory": "Factory",
            "floorplan_opt_church": "Church",
            "floorplan_opt_data_centre": "Data centre",
            "floorplan_opt_casino": "Casino",
            "floorplan_opt_corp_office": "Corporate office",
            "floorplan_opt_street_doc": "Street doc",
            "floorplan_opt_cosmetic_clinic": "Cosmetic clinic",
            "floorplan_opt_coffin_block": "Coffin motel",
            "floorplan_opt_stuffer_shack": "Stuffer Shack",
            "floorplan_opt_dive_bar": "Dive bar",
            "floorplan_opt_chop_shop": "Chop shop",
            "floorplan_opt_gun_shop": "Gun shop",
            "floorplan_opt_talismonger": "Talismonger",
            "floorplan_opt_ramen_bar": "Ramen bar",
            "floorplan_opt_boutique": "Boutique",
            "floorplan_opt_deli": "Deli",
            "floorplan_opt_safehouse": "Safehouse",
            "floorplan_opt_hacker_den": "Hacker den",
            "floorplan_opt_mage_flat": "Mage flat",
            "floorplan_opt_prison": "Prison",
            "tab_header_npc_list": "NPCs",
            "tab_header_npc_create": "NPCs",
            "tab_header_locations_list": "Locations",
            "tab_header_locations_create": "Locations",
            "tab_header_customs_list": "Image generator",
            "tab_header_customs_create": "Image generator",
            "tab_header_favorites_list": "Favourites",
            "tab_header_own_list": "My entries",
            "tab_header_npcs_default": "NPC",
            "tab_header_npcs_sr6": "SR6",
            "tab_header_npcs_sr5": "SR5",
            "tab_header_npcs_gallery": "Gallery",
            "tab_header_locations_default": "Location",
            "tab_header_locations_reviews": "Reviews",
            "tab_header_locations_gallery": "Gallery",
            "entity_create": "Create",
            "entity_generate_data": "Generating missing data ...",
            "entity_download": "Download",
            "entity_download_title": "Download",
            "entity_download_format_picker": "Choose the format:",
            "entity_download_foundryvtt": "(SR6) Foundry VTT",
            "entity_download_foundryvtt_description1": "Create a new \"Actor\" in Foundry.",
            "entity_download_foundryvtt_description2": "Right-click the actor -> \"Import data\".",
            "entity_download_foundryvtt_description3": "Choose the downloaded file.",
            "entity_download_foundryvtt_description4": "If the image is missing, import the file again.",
            "entity_download_error": "Export failed. Please fill in the NPC completely and try again.",
            "entity_download_roll20": "(SR6) Roll20",
            "entity_download_roll20_description1": "Open the Shadowrun 6 character sheet in Roll20 and the \"Import\" tab.",
            "entity_download_roll20_description2": "Upload the downloaded JSON file.",
            "entity_save": "Publish",
            "entity_favorite": "Favourite",
            "attribute_type": "Type",
            "attribute_special_features": "Special features",
            "attribute_remarks": "Remarks",
            "attribute_security_systems": "Security",
            "attribute_events": "Events",
            "attribute_rumors_and_stories": "Rumours",
            "tab_loading_text": "Generating data...",
            "npc_card_title_background": "Background",
            "npc_card_title_social": "Social",
            "npc_card_title_personality": "Personality",
            "npc_card_title_skills_and_traits": "Traits",
            "npc_attribute_bod": "Bod",
            "npc_attribute_agi": "Agi",
            "npc_attribute_rea": "Rea",
            "npc_attribute_str": "Str",
            "npc_attribute_wil": "Wil",
            "npc_attribute_log": "Log",
            "npc_attribute_int": "Int",
            "npc_attribute_cha": "Cha",
            "npc_attribute_edg": "Edg",
            "npc_attribute_mag": "Mag",
            "npc_attribute_res": "Res",
            "npc_skill_astral": "Astral",
            "npc_skill_athletics": "Athletics",
            "npc_skill_biotech": "Biotech",
            "npc_skill_close_combat": "Close Combat",
            "npc_skill_con": "Con",
            "npc_skill_conjuring": "Conjuring",
            "npc_skill_cracking": "Cracking",
            "npc_skill_electronics": "Electronics",
            "npc_skill_enchanting": "Enchanting",
            "npc_skill_engineering": "Engineering",
            "npc_skill_exotic_weapons": "Exotic Weapons",
            "npc_skill_firearms": "Firearms",
            "npc_skill_influence": "Influence",
            "npc_skill_outdoors": "Outdoors",
            "npc_skill_perception": "Perception",
            "npc_skill_piloting": "Piloting",
            "npc_skill_sorcery": "Sorcery",
            "npc_skill_stealth": "Stealth",
            "npc_skill_tasking": "Tasking",
            "npc_sr5_skill_archery": "Archery",
            "npc_sr5_skill_automatics": "Automatics",
            "npc_sr5_skill_blades": "Blades",
            "npc_sr5_skill_clubs": "Clubs",
            "npc_sr5_skill_exotic_melee_weapon": "Exotic Melee Weapon",
            "npc_sr5_skill_exotic_ranged_weapon": "Exotic Ranged Weapon",
            "npc_sr5_skill_heavy_weapons": "Heavy Weapons",
            "npc_sr5_skill_longarms": "Longarms",
            "npc_sr5_skill_pistols": "Pistols",
            "npc_sr5_skill_throwing_weapons": "Throwing Weapons",
            "npc_sr5_skill_unarmed_combat": "Unarmed Combat",
            "npc_sr5_skill_gunnery": "Gunnery",
            "npc_sr5_skill_disguise": "Disguise",
            "npc_sr5_skill_diving": "Diving",
            "npc_sr5_skill_escape_artist": "Escape Artist",
            "npc_sr5_skill_free_fall": "Free-Fall",
            "npc_sr5_skill_gymnastics": "Gymnastics",
            "npc_sr5_skill_locksmith": "Locksmith",
            "npc_sr5_skill_palming": "Palming",
            "npc_sr5_skill_perception": "Perception",
            "npc_sr5_skill_running": "Running",
            "npc_sr5_skill_sneaking": "Sneaking",
            "npc_sr5_skill_survival": "Survival",
            "npc_sr5_skill_swimming": "Swimming",
            "npc_sr5_skill_tracking": "Tracking",
            "npc_sr5_skill_animal_handling": "Animal Handling",
            "npc_sr5_skill_con": "Con",
            "npc_sr5_skill_etiquette": "Etiquette",
            "npc_sr5_skill_impersonation": "Impersonation",
            "npc_sr5_skill_instruction": "Instruction",
            "npc_sr5_skill_intimidation": "Intimidation",
            "npc_sr5_skill_leadership": "Leadership",
            "npc_sr5_skill_negotiation": "Negotiation",
            "npc_sr5_skill_performance": "Performance",
            "npc_sr5_skill_alchemy": "Alchemy",
            "npc_sr5_skill_arcana": "Arcana",
            "npc_sr5_skill_artificing": "Artificing",
            "npc_sr5_skill_assensing": "Assensing",
            "npc_sr5_skill_astral_combat": "Astral Combat",
            "npc_sr5_skill_banishing": "Banishing",
            "npc_sr5_skill_binding": "Binding",
            "npc_sr5_skill_counterspelling": "Counterspelling",
            "npc_sr5_skill_disenchanting": "Disenchanting",
            "npc_sr5_skill_ritual_spellcasting": "Ritual Spellcasting",
            "npc_sr5_skill_spellcasting": "Spellcasting",
            "npc_sr5_skill_summoning": "Summoning",
            "npc_sr5_skill_compiling": "Compiling",
            "npc_sr5_skill_decompiling": "Decompiling",
            "npc_sr5_skill_registering": "Registering",
            "npc_sr5_skill_aeronautics_mechanic": "Aeronautics Mechanic",
            "npc_sr5_skill_armorer": "Armorer",
            "npc_sr5_skill_artisan": "Artisan",
            "npc_sr5_skill_automotive_mechanic": "Automotive Mechanic",
            "npc_sr5_skill_biotechnology": "Biotechnology",
            "npc_sr5_skill_chemistry": "Chemistry",
            "npc_sr5_skill_computer": "Computer",
            "npc_sr5_skill_cybercombat": "Cybercombat",
            "npc_sr5_skill_cybertechnology": "Cybertechnology",
            "npc_sr5_skill_demolitions": "Demolitions",
            "npc_sr5_skill_electronic_warfare": "Electronic Warfare",
            "npc_sr5_skill_first_aid": "First Aid",
            "npc_sr5_skill_forgery": "Forgery",
            "npc_sr5_skill_hacking": "Hacking",
            "npc_sr5_skill_hardware": "Hardware",
            "npc_sr5_skill_industrial_mechanic": "Industrial Mechanic",
            "npc_sr5_skill_medicine": "Medicine",
            "npc_sr5_skill_nautical_mechanic": "Nautical Mechanic",
            "npc_sr5_skill_navigation": "Navigation",
            "npc_sr5_skill_software": "Software",
            "npc_sr5_skill_pilot_aerospace": "Pilot Aerospace",
            "npc_sr5_skill_pilot_aircraft": "Pilot Aircraft",
            "npc_sr5_skill_pilot_exotic_vehicle": "Pilot Exotic Vehicle",
            "npc_sr5_skill_pilot_ground_craft": "Pilot Ground Craft",
            "npc_sr5_skill_pilot_walker": "Pilot Walker",
            "npc_sr5_skill_pilot_watercraft": "Pilot Watercraft",
            "npc_sr5_category_combat": "Combat",
            "npc_sr5_category_physical": "Physical",
            "npc_sr5_category_social": "Social",
            "npc_sr5_category_magical": "Magical",
            "npc_sr5_category_resonance": "Resonance",
            "npc_sr5_category_technical": "Technical",
            "npc_sr5_category_vehicle": "Vehicle",
            "npc_entity_is_not_published": "This NPC has not been published yet and can only be reached through its exact URL. Save the link to access it later.",
            "npc_skill": "Skill",
            "npc_skill_value": "Value",
            "npc_physical_condition": "Physical",
            "npc_stun_condition": "Stun",
            "location_entity_is_not_published": "This location has not been published yet and can only be reached through its exact URL. Save the link to access it later.",
            "auth_signup": "Sign up",
            "auth_signup_description": "No account yet? Sign up here",
            "app_name": "Shadow File - Shadowrun NPC Generator",
            "prompt_failed_connection": "Connection issues. Please try again later.",
            "input_was_flagged_by_gpt": "The input was filtered by GPT moderation. Try again or enter something else.",
            "npc_was_flagged_by_gpt": "The NPC was considered inappropriate by GPT. Try again or enter something else.",
            "gpt_raised_an_error": "GPT encountered an error. Please try again later.",
            "npc_incomplete": "The NPC is incomplete. Please fill out all fields before saving.",
            "image_generation_in_progress": "The image is still being generated. Please refresh this page again in a few minutes.",
            "prompt_wait": "Generating... please wait...",

            "menu_npcs": "NPCs",
            "menu_locations": "Locations",
            "menu_critters": "Critters",
            "menu_vehicles": "Vehicles",
            "menu_customs": "Image Generator",
            "menu_feedback": "Feedback",
            "menu_impressum": "Impressum",
            "tab_header_floorplans_list": "Floorplans",
            "tab_header_floorplans_create": "Floorplans",
            "menu_floorplans": "Floorplans",
            "floorplan_list_empty_text": "There are no published floorplans yet. Click the plus to create one.",
            "page_floorplan_create_title": "Shadow File - Floorplan",
            "create_explanation_floorplan": "Set up the building and generate a floorplan with rooms, doors, furniture and security devices. A floorplan cannot be changed; other settings make a new one.",
            "floorplan_is_not_published": "This floorplan has not been published yet and can only be reached through its exact URL. Save the link to get back to it later.",
            "floorplan_options_failed": "The settings could not be loaded.",
            "floorplan_load_failed": "The floorplan could not be loaded.",
            "floorplan_loading": "Loading...",
            "floorplan_queued": "Waiting to be generated...",
            "floorplan_rendering": "Creating the floorplan...",
            "floorplan_failed": "The floorplan could not be created.",
            "floorplan_empty": "Set the parameters on the left and click Generate.",
            "floorplan_floor_ground": "Ground floor",
            "floorplan_floor_upper": "Floor {{level}}",
            "floorplan_floor_basement": "Basement {{level}}",
            "floorplan_download": "Download",
            "floorplan_unpublished": "Not published",
            "floorplan_published": "Published",
            "floorplan_to_list": "To the list",
            "floorplan_opt_N": "N (north)",
            "floorplan_opt_E": "E (east)",
            "floorplan_opt_S": "S (south)",
            "floorplan_opt_W": "W (west)",
            "floorplan_publish": "Publish",
            "floorplan_generate": "Generate",
            "floorplan_floors_one": "{{count}} floor",
            "floorplan_floors_other": "{{count}} floors",
            "floorplan_building": "Building",
            "floorplan_character": "Character",
            "floorplan_site": "Site",
            "floorplan_image": "Image",
            "floorplan_type": "Type",
            "floorplan_width": "Width (cells)",
            "floorplan_depth": "Depth (cells)",
            "floorplan_floors_above": "Floors above",
            "floorplan_floors_below": "Basements",
            "floorplan_shape": "Shape",
            "floorplan_layout": "Layout",
            "floorplan_layout_default": "building type's own",
            "floorplan_opt_partition": "Partition (straight corridors)",
            "floorplan_opt_partition_diagonal": "Partition, diagonal corridors",
            "floorplan_opt_partition_osm": "Partition, corridors of real buildings (OSM)",
            "floorplan_wealth": "Wealth",
            "floorplan_condition": "Condition",
            "floorplan_security": "Security",
            "floorplan_street_side": "Street side",
            "floorplan_service_side": "Service side",
            "floorplan_opposite_of_street": "opposite of street",
            "floorplan_seed": "Seed",
            "floorplan_random": "random",
            "floorplan_reroll": "Random seed",
            "floorplan_follows_layout": "like layout seed",
            "floorplan_seed_layout": "Layout",
            "floorplan_seed_rooms": "Rooms",
            "floorplan_seed_furniture": "Furniture",
            "floorplan_seed_security": "Security",
            "floorplan_osm_credit": "Shapes taken from real buildings:",
            "floorplan_light_word": "light",
            "floorplan_theme": "Theme",
            "floorplan_layers": "Layers",
            "floorplan_floor_list": "Floors",
            "floorplan_role": "Role",
            "floorplan_unit": "Unit",
            "floorplan_zoom_in": "Zoom in",
            "floorplan_zoom_out": "Zoom out",
            "floorplan_zoom_fit": "Fit",
            "floorplan_dd2vtt_hint": "Universal VTT, e.g. for Roll20 or Foundry",
            "floorplan_layer_image": "Image",
            "floorplan_layer_labels": "Room descriptions",
            "floorplan_layer_objects": "Furniture",
            "floorplan_layer_matrix": "Matrix devices",
            "floorplan_layer_grid": "Grid",

            "menu_login": "Login",
            "menu_register": "Register",
            "menu_logout": "Logout",
            "page_list_title_npcs": "Schattenakte - NPC List",
            "page_list_description_npcs": "List of all generated NPCs",
            "page_list_title_locations": "Schattenakte - Location List",
            "page_list_description_locations": "List of all generated locations",
            "page_list_title_customs": "Schattenakte - NPC List",
            "page_list_description_customs": "List of all generated custom images",
            "create_explanation_npc": "Describe your NPC. You can specify appearance, profession, background, or even stats, and GPT will generate the rest. You can modify it later.",
            "create_explanation_location": "Describe the location. You can add the area or a rough description. GPT will generate the rest. You can modify it later.",
            "create_explanation_custom": "Describe something roughly and let GPT fill it in - or directly specify the appearance below",
            "attribute_metatype": "Metatype",
            "attribute_profession": "Profession",
            "attribute_ethnicity": "Ethnicity",
            "attribute_gender": "Gender",
            "attribute_age": "Age",
            "attribute_quirks": "Quirks",
            "attribute_appearance": "Appearance",
            "attribute_backstory": "Backstory",
            "attribute_experiences": "Experiences",
            "attribute_resentments": "Resentments",
            "attribute_motivations": "Motivation",
            "attribute_hobbies_and_interests": "Hobbies",
            "attribute_family": "Family",
            "attribute_contacts": "Contacts",
            "attribute_konzernzugehörigkeit": "Corporation",
            "attribute_strengths": "Strengths",
            "attribute_weaknesses": "Weaknesses",
            "attribute_skills": "Skills",
            "attribute_equipment": "Equipment",
            "attribute_secret": "Secret",
            "attribute_name": "Name",
            "attribute_typ": "Type",
            "attribute_aussehen": "Appearance",
            "attribute_stadtteil_zone": "Area",
            "attribute_zugehörige_gruppe_corp_fraktion": "Affiliation",
            "attribute_besonderheiten": "Special Features",
            "attribute_hinweise": "Hints",
            "attribute_verfügbarkeit_von_sicherheitssystemen": "Security",
            "attribute_aktuelle_aktionen_events": "Actions",
            "attribute_gerüchte_und_geschichten_über_die_location": "Rumors",
            "attribute_parameter": "Parameter",
            "metatype_human": "Human",
            "metatype_ork": "Ork",
            "metatype_dwarf": "Dwarf",
            "metatype_elf": "Elf",
            "metatype_troll": "Troll",
            "metatype_spirit": "Spirit",
            "metatype_ai": "AI",
            "metatype_ogre": "Ogre",
            "metatype_drake": "Drake",
            "metatype_oni": "Oni",
            "metatype_hobgoblin": "Hobgoblin",
            "metatype_other": "Other",
            "metatype_giant": "Giant",
            "metatype_cyclop": "Cyclops",
            "metatype_minotaur": "Minotaur",
            "metatype_fomorian": "Fomorian",
            "metatype_satyr": "Satyr",
            "metatype_nocturne": "Nocturne",
            "metatype_wakyambi": "Wakyambi",
            "metatype_xapiri": "Xapiri",
            "metatype_dryad": "Dryad",
            "metatype_dalakitnon": "Dalakitnon",
            "metatype_valkyrie": "Valkyrie",
            "metatype_nartaki": "Nartaki",
            "metatype_duende": "Duende",
            "metatype_hanuman": "Hanuman",
            "metatype_menehune": "Menehune",
            "metatype_koborokuru": "Koborokuru",
            "metatype_gnome": "Gnome",
            "metatype_centaur": "Centaur",
            "metatype_naga": "Naga",
            "metatype_pixie": "Pixie",
            "metatype_sasquatch": "Sasquatch",
            "gender_male": "Male",
            "gender_female": "Female",
            "gender_divers": "Diverse",
            "gender_other": "Other",
            "--s 50": "stylize low",
            "--s 100": "stylize medium",
            "--s 250": "stylize high",
            "--s 750": "stylize very high",
            "--ar 1:1": "Square (1:1)",
            "--ar 2:3": "Tall (2:3)",
            "--ar 4:7": "Portrait (4:7)",
            "--ar 3:2": "Wide (3:2)",
            "--ar 7:4": "Landscape (7:4)",
            "--chaos 0": "No Chaos",
            "--chaos 7": "Low Chaos",
            "--chaos 25": "Medium Chaos",
            "--chaos 50": "High Chaos",
            "--chaos 100": "Maximum Chaos"
        }
    },
};

// NPC attributes whose stored value is a canonical english enum token
// (see backend Metatype / Gender). The token is kept as-is in entity.values;
// only the displayed text is localized via the `<attr>_<token>` keys above.
const ENUM_VALUE_ATTRIBUTES = ['metatype', 'gender'];

export function translateAttributeValue(attributeName, value) {
    if (value === null || value === undefined) return value;
    if (!ENUM_VALUE_ATTRIBUTES.includes(attributeName)) return value;

    const token = String(value).trim().toLowerCase();
    if (!token) return value;

    return i18next.t(`${attributeName}_${token}`, {defaultValue: String(value)});
}

const LANGUAGES = ["de", "en"];
const LANGUAGE_KEY = "language";

/** The saved choice, else the browser's language, else German. */
function initialLanguage() {
    try {
        const saved = localStorage.getItem(LANGUAGE_KEY);
        if (LANGUAGES.includes(saved)) return saved;
    } catch (e) { /* storage blocked: fall through */ }
    return (navigator.language || "de").toLowerCase().startsWith("en") ? "en" : "de";
}

/** The pages read their texts when they render, so a switch reloads the page. */
export function setLanguage(language) {
    if (!LANGUAGES.includes(language) || language === i18next.language) return;
    try { localStorage.setItem(LANGUAGE_KEY, language); } catch (e) { /* not persisted */ }
    window.location.reload();
}
export {LANGUAGES};

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLanguage(),
        fallbackLng: {de: ["en"], en: ["de"], default: ["de"]},
        interpolation: {
            escapeValue: false,
        },
        debug: true
    });
document.documentElement.lang = i18next.language;

export default i18next;